import Image from 'next/image';
import Link from 'next/link';

const PurposeBuildSection = ({ heading, paragraph, featureCards }) => (
  <div className="w-full flex flex-col justify-center items-center bg-[#F0F0F0] lg:py-20 lg:px-20 py-10 px-10 font-inter gap-7 max-w-[1750px] mx-auto">
    <div className="flex flex-col justify-center items-center gap-y-16 w-full">
      {/* Heading + Paragraph */}
      <div className="flex flex-col justify-center items-center gap-y-10 w-full">
        <h2 className="lg:text-5xl text-2xl font-inter font-bold md:leading-[50px] text-[#172554] text-center">
          {heading}
        </h2>
        <p className="text-[#686868] lg:text-xl text-base font-normal leading-7 lg:max-w-[1280px] w-full md:text-center">
          {paragraph}
        </p>
      </div>

      {/* Feature Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 place-items-center max-w-[1280px] mx-auto">
        {featureCards.map((item, index) => (
          <div
            key={index}
            className="flex flex-col border-2 rounded-sm hover:shadow-[2px_2px_10px_0px_#807E7E21] w-full max-w-[380px] min-h-[380px] bg-[#ffffff]"
          >
            {/* Header */}
            <div className="flex flex-row bg-gradient-to-r from-[#2E6AB3] to-[#063696] py-4 px-8 rounded-sm min-h-[140px]">
              <div className="flex flex-row items-center gap-x-6">
                <div className="w-[56px] h-[56px] flex items-center justify-center bg-[#FFFFFF33] rounded-sm">
                  <Image
                    src={item.icon}
                    alt={item.title.toLowerCase().replace(/\s+/g, '-')}
                    className="w-[36px] h-[36px] object-contain"
                  />
                </div>
                <div className="flex flex-col">
                  <h2 className="text-[#ffffff] font-inter font-semibold text-lg md:text-2xl leading-snug max-w-[250px]">
                    {item.title}
                  </h2>
                </div>
              </div>
            </div>

            {/* Description */}
            <div className="text-[#525252] flex items-start font-normal lg:text-lg text-base p-4">
              <p>{item.description}</p>
            </div>
          </div>
        ))}
      </div>

      {/* CTA Button */}
      <div className="flex justify-center items-center">
        <Link href="/contact?ref=purpose-build-section&utm_source=website&utm_medium=cta&utm_campaign=services&utm_content=services__purpose_build__book_a_demo">
          <button
            type="button"
            className="text-white bg-[#046DEB] md:font-medium font-normal rounded-full  transition-all duration-300 ease-out hover:scale-105 hover:bg-[#0056b3] sm:text-xs lg:text-base lg:px-8 lg:py-4 px-6 py-2 text-center"
          >
            Book a Demo
          </button>
        </Link>
      </div>
    </div>
  </div>
);

export default PurposeBuildSection;
